import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedHTMLMessage } from 'react-intl'
import * as bootupSelectors from 'services/bootup/selectors'
import styles from './_privacyStyles.css'

const mapStateToProps = (state) => ({
  accountPortalRoot: bootupSelectors.selectAccountPortalRoot(state),
})

function StickyFooter (props) {
  const { accountPortalRoot, children } = props
  const termsLink = `${accountPortalRoot}/terms-and-conditions`
  const privacyLink = `${accountPortalRoot}/privacy`

  return (<div className={styles.privacyFooter}>
    <FormattedHTMLMessage
      id='privacy_center.privacy_and_terms'
      defaultMessage={'<a href="{ privacyLink }" target="_blank">Privacy Policy</a> & <a href="{ termsLink }" target="_blank">Terms of Use</a>.'}
      values={ {
        termsLink,
        privacyLink,
      } }
    />
    { children }
  </div>)
}

StickyFooter.propTypes = {
  accountPortalRoot: PropTypes.string,
  children: PropTypes.object,
}

export default connect(mapStateToProps, {})(StickyFooter)
